import React from 'react'
import {Carousel} from '../components/Layout/Elements'

 const Img_carousel = ({ images, handleIndexImg  }) => {
     

    const [check, setCheck] = React.useState(0)
     const CheckifSame = (index) => {
      setCheck(index)
     }
     
    return (
        <Carousel>
            { images.map((image, index) => {
              return (
                   <img className={check === index ? 'bottom-images bottom-border' : 'bottom-images'} key={index}  src={image.url} onClick={() => {
                  handleIndexImg(index)
                  CheckifSame(index)
              }}  alt="dish"/>
              )
            })}
        </Carousel>
    )
}

export { Img_carousel as default };
